export const baseUrl = "http://api.suresearchsoftware.com/api";
// http://103.167.211.212:81/api/
